// Mirrors io.netfoundry.identity.domain.organization.Auth0ConnectionType in the identity service.
// Serialized on every IdentityProvider as `auth0ConnectionType` (a @NotNull field), so it is always
// present on the providers embedded in an organization/tenant payload.
//
// Values are explicit strings — unlike the numeric enums elsewhere in this folder — because they are
// compared directly against the wire format. A bare `enum { Database }` would be 0, never 'Database'.
export enum Auth0ConnectionType {
    Database = 'Database',
    Social = 'Social',
    Enterprise = 'Enterprise',
    Passwordless = 'Passwordless',
}
